import { render, staticRenderFns } from "./PublisherLogo.vue?vue&type=template&id=d1f9aecc&scoped=true&lang=pug&"
import script from "./PublisherLogo.vue?vue&type=script&lang=js&"
export * from "./PublisherLogo.vue?vue&type=script&lang=js&"
import style0 from "./PublisherLogo.vue?vue&type=style&index=0&id=d1f9aecc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f9aecc",
  null
  
)

export default component.exports